import { PropsWithChildren } from 'react';
import { useIsomorphicLayoutEffect } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import { useRadioGroupContext, useRadioItemContext } from './context';

import css from './styles.module.css';

export interface RadioGroupDescriptionProps extends PropsWithChildren {
  className?: string;
}

/** Secondary text under the label. */
export function RadioGroupDescription({
  className,
  children,
}: RadioGroupDescriptionProps) {
  const { registerDescription } = useRadioGroupContext();
  const { id } = useRadioItemContext();

  // Layout effect so the group's column count settles before the first paint.
  useIsomorphicLayoutEffect(
    () => registerDescription(id),
    [registerDescription, id]
  );

  return <span className={cn(css.description, className)}>{children}</span>;
}
